import { Typography } from '@mui/joy';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getDataOfSharedId } from '../../controllers/currentTabData';
import Layout from '../../Layout';
import { IDataCategoryLinks } from '../../types';
import SingleCategory from '../DashboardComponents/SingleCategory';
import NavBar from './NavBar'

const SharedLinks = () => {

	const { shareid } = useParams();
	const [data, setData] = useState<IDataCategoryLinks>({ _id: "", tagName: "", links: [{ _id: "", title: "", url: "" }] });
	// const [shared, setShared] = useState(true);
	const shared = true;

	useEffect(() => {
		async function getData() {
			const resp = await getDataOfSharedId(shareid);
			setData(resp);
		}

		getData();

	}, [shareid]);

	if (!data) {
		return (
			<>
				<NavBar />
				<Layout>
					<Typography sx={{ textAlign: "center" }} level='h3'>
						Invalid category
					</Typography>
				</Layout>
			</>
		)
	}

	return (
		<>
			<NavBar />
			<Layout>
				<SingleCategory shared={shared} data={data} />
			</Layout>
		</>
	)
}

export default SharedLinks